import React from 'react';

const Hero = () => {

  return (
    <div className="bg-cover bg-center h-screen flex flex-col md:flex-row items-center banner">
    </div>
  );
};

export default Hero;
